<template lang="pug">
  v-container(fluid=true class="grey lighten-5")
    div
      h1 Marketing
    
</template>
<script>
export default {

}
</script>
